import React, { useState } from 'react';
import { Modal, Image } from 'antd';

const ImageFile = ({ src, title, visible, setVisible }) => {
  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      title={title}
      footer={null}
      centered
      width="auto"
      style={{ top: 20 }}
    >
      <Image src={src} style={{ width: '100%', maxHeight: '80vh' }} alt={title} />
    </Modal>
  );
};

const PdfFile = ({ src, title, visible, setVisible }) => {
  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(false)}
      title={title}
      footer={null}
      centered
      width="auto"
      style={{ top: 20 }}
    >
      <iframe
        src={src}
        style={{ width: '100%', height: '80vh', border: 'none' }}
        title={title}
        allow="fullscreen"
      />
    </Modal>
  );
};

const FileRenderer = ({ uri, title, visible, setVisible }) => {
  const extension = uri.split('.').pop().toLowerCase();

  switch (extension) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
      return <ImageFile src={uri} title={title} visible={visible} setVisible={setVisible} />;
    case 'pdf':
      return <PdfFile src={uri} title={title} visible={visible} setVisible={setVisible} />;
    default:
      return <p>Unsupported file type</p>;
  }
};


export default FileRenderer;
